import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '../../bits/Button.jsx';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle';

import TextField from '@mui/material/TextField';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';

const LocationHistorySearchPanelStyled = styled.div`
`;

const Field = styled.div`
margin-top: 30px;
margin-bottom: 35px;
`;

const Footer = styled.div`
`;

interface LocationHistorySearchPanelProps {
  onSave: (startAt: Date, endAt: Date) => void;
}

/**
 * Renders a location history search window. 
 */
export const LocationHistorySearchPanel: React.FC<LocationHistorySearchPanelProps> = ({ onSave }) => {
  const [startAt, setStartAt] = useState<Date | null>(null);
  const [endAt, setEndAt] = useState<Date | null>(null);

  useSetModalTitle('Location History');

  useEffect(() => {
    setStartAt(moment().startOf('day'))
    setEndAt(moment());
  }, []);

  const handleSubmit = () => {
    onSave(startAt, endAt);
  };
  
  return (
    <LocationHistorySearchPanelStyled>
      <Field>
        <DateTimePicker
          renderInput={(props) => <TextField {...props} fullWidth/>}
          label="Start time"
          value={startAt}
          onChange={newValue => setStartAt(newValue)}
        />
      </Field>


      <Field>
        <DateTimePicker
          renderInput={(props) => <TextField {...props} fullWidth />}
          label="End time"
          value={endAt}
          onChange={newValue => setEndAt(newValue)}
        />
      </Field>

      <Footer>
        <Button loading={false} onClick={handleSubmit} color="primary">Load</Button>
      </Footer>
    </LocationHistorySearchPanelStyled>
  )
};
